import { Button, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { automationList, getAutomationReport } from '../../services/automation';
import { useNavigate } from 'react-router-dom';

const AutomationList = ({ userStore }) => {
  const [list, setList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    automationList(userStore).then((response) => {
      setList(response.data);
    }).catch((error) => {
      console.log(error);
    });
  }, []);
  return (
    <div>
      <Button variant="contained" onClick={e => navigate('/app/automation/actions')}>Criar Interação</Button>
      <br /><br />
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Criado</TableCell>
                <TableCell>Ações</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Usuários</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list !== null && list.map((automation) => (
                <TableRow key={automation.id}>
                  <TableCell>{automation.created_at}</TableCell>
                  <TableCell>{automation.action}</TableCell>
                  <TableCell>{automation.status}</TableCell>
                  <TableCell><Button onClick={e => getAutomationReport(userStore, automation.id)}>Download</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
};

export default AutomationList;
